{
  "familyId": "TOPO-EU-BUURLANDEN",
  "questions": [
    {
      "id": "TOPO-EU-BUURLANDEN-001",
      "familyId": "TOPO-EU-BUURLANDEN",
      "module": "Topo",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_buurlanden_eu",
      "questionType": "multiple_choice",
      "question": "Welk land grenst NIET aan Frankrijk?",
      "options": [
        "Nederland",
        "Spanje",
        "Italië",
        "België"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van europa",
            "region": "europa",
            "highlight": "topo_buurlanden_eu"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Buurlanden van Frankrijk",
            "content": "Frankrijk grenst aan: België, Luxemburg, Duitsland, Zwitserland, Italië, Spanje, Andorra en Monaco. Nederland grenst NIET aan Frankrijk.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "buurlanden_frankrijk",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Nederland grenst niet aan Frankrijk. Tussen Nederland en Frankrijk ligt België. Frankrijk grenst wel aan Spanje (in het zuiden), Italië (in het zuidoosten) en België (in het noorden).",
        "solutionSteps": [
          "Frankrijk grenst aan: België, Luxemburg, Duitsland, Zwitserland, Italië, Spanje, Andorra, Monaco",
          "Nederland ligt ten noorden van België",
          "Tussen Nederland en Frankrijk ligt België → geen grens ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Nederland grenst niet aan Frankrijk. België ligt ertussen.",
          "1": "Je dacht waarschijnlijk dat Spanje niet aan Frankrijk grenst. Maar Spanje en Frankrijk delen een grens in de Pyreneeën (het gebergte in het zuiden). Onthoud: de Pyreneeën vormen de grens.",
          "2": "Je dacht waarschijnlijk dat Italië niet aan Frankrijk grenst. Maar Italië en Frankrijk delen een grens in het zuidoosten, bij de Alpen. Onthoud: de Alpen vormen de grens.",
          "3": "Je dacht waarschijnlijk dat België niet aan Frankrijk grenst. Maar België en Frankrijk delen een lange grens in het noorden van Frankrijk. Onthoud: België is een buurland van Frankrijk."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-BUURLANDEN-001-OPT1",
            "optionIndex": 1,
            "label": "Denkfout: Spanje niet aan Frankrijk grenst"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-BUURLANDEN-001-OPT2",
            "optionIndex": 2,
            "label": "Denkfout: Italië niet aan Frankrijk grenst"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-BUURLANDEN-001-OPT3",
            "optionIndex": 3,
            "label": "Denkfout: België niet aan Frankrijk grenst"
          }
        ]
      }
    },
    {
      "id": "TOPO-EU-BUURLANDEN-002",
      "familyId": "TOPO-EU-BUURLANDEN",
      "module": "Topo",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_buurlanden_eu",
      "questionType": "multiple_choice",
      "question": "Aan hoeveel landen grenst Duitsland?",
      "options": [
        "9",
        "6",
        "4",
        "12"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van europa",
            "region": "europa",
            "highlight": "topo_buurlanden_eu"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Buurlanden van Duitsland",
            "content": "Duitsland heeft 9 buurlanden: Nederland, België, Luxemburg, Frankrijk, Zwitserland, Oostenrijk, Tsjechië, Polen en Denemarken.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "buurlanden_duitsland",
      "variantIndex": 2,
      "citoDifficulty": 0.4,
      "citoDiscrimination": 0.7,
      "feedback": {
        "explanationText": "Duitsland grenst aan 9 landen: Nederland, België, Luxemburg, Frankrijk, Zwitserland, Oostenrijk, Tsjechië, Polen en Denemarken. Het is een van de landen met de meeste buurlanden in Europa.",
        "solutionSteps": [
          "West: Nederland, België, Luxemburg, Frankrijk",
          "Zuid: Zwitserland, Oostenrijk",
          "Oost: Tsjechië, Polen",
          "Noord: Denemarken",
          "Totaal: 9 buurlanden ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Duitsland heeft 9 buurlanden.",
          "1": "Je dacht waarschijnlijk dat het er 6 zijn. Misschien heb je de kleinere landen (Luxemburg, Denemarken) of de oostelijke landen (Tsjechië, Polen) vergeten. Onthoud: Duitsland ligt midden in Europa en heeft veel buren.",
          "2": "Je dacht waarschijnlijk dat het er maar 4 zijn. Maar Duitsland is een groot land in het midden van Europa. Onthoud: hoe centraler een land ligt, hoe meer buurlanden het vaak heeft.",
          "3": "Je dacht waarschijnlijk dat het er 12 zijn. Maar 12 is te veel — geen enkel Europees land heeft zoveel buurlanden. Onthoud: Duitsland heeft er 9, het meeste in West-Europa."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-BUURLANDEN-002-OPT1",
            "optionIndex": 1,
            "label": "Denkfout: het er 6 zijn"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-BUURLANDEN-002-OPT2",
            "optionIndex": 2,
            "label": "Denkfout: het er maar 4 zijn"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-BUURLANDEN-002-OPT3",
            "optionIndex": 3,
            "label": "Denkfout: het er 12 zijn"
          }
        ]
      }
    },
    {
      "id": "TOPO-EU-BUURLANDEN-003",
      "familyId": "TOPO-EU-BUURLANDEN",
      "module": "Topo",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_buurlanden_eu",
      "questionType": "multiple_choice",
      "question": "Welk land grenst aan zowel Duitsland als Italië?",
      "options": [
        "Zwitserland",
        "België",
        "Polen",
        "Spanje"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van europa",
            "region": "europa",
            "highlight": "topo_buurlanden_eu"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gemeenschappelijke buurlanden",
            "content": "Zwitserland en Oostenrijk liggen tussen Duitsland en Italië. Beide landen grenzen aan zowel Duitsland als Italië.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "buurlanden_gemeenschappelijk",
      "variantIndex": 3,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Zwitserland grenst aan zowel Duitsland (in het noorden) als Italië (in het zuiden). Het ligt in de Alpen, precies tussen deze twee landen.",
        "solutionSteps": [
          "Welk land ligt tussen Duitsland en Italië?",
          "De Alpen liggen ertussen",
          "Zwitserland ligt in de Alpen → grenst aan beide ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Zwitserland grenst aan Duitsland én Italië.",
          "1": "Je dacht waarschijnlijk dat België aan Italië grenst. Maar België ligt in het noordwesten van Europa, ver van Italië. Onthoud: België grenst aan Nederland, Duitsland, Luxemburg en Frankrijk.",
          "2": "Je dacht waarschijnlijk dat Polen aan Italië grenst. Maar Polen ligt in het oosten van Europa, ver van Italië. Onthoud: Polen grenst aan Duitsland, Tsjechië, Slowakije, Oekraïne, Wit-Rusland en Litouwen.",
          "3": "Je dacht waarschijnlijk dat Spanje aan Duitsland grenst. Maar Spanje ligt in het zuidwesten, ver van Duitsland. Onthoud: Spanje grenst aan Frankrijk en Portugal."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-BUURLANDEN-003-OPT1",
            "optionIndex": 1,
            "label": "Denkfout: België aan Italië grenst"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-BUURLANDEN-003-OPT2",
            "optionIndex": 2,
            "label": "Denkfout: Polen aan Italië grenst"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-BUURLANDEN-003-OPT3",
            "optionIndex": 3,
            "label": "Denkfout: Spanje aan Duitsland grenst"
          }
        ]
      }
    },
    {
      "id": "TOPO-EU-BUURLANDEN-004",
      "familyId": "TOPO-EU-BUURLANDEN",
      "module": "Topo",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_buurlanden_eu",
      "questionType": "multiple_choice",
      "question": "Welk Europees land is een eiland en heeft daarom GEEN buurlanden op het vasteland?",
      "options": [
        "IJsland",
        "Noorwegen",
        "Griekenland",
        "Portugal"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van europa",
            "region": "europa",
            "highlight": "topo_buurlanden_eu"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Eilandlanden in Europa",
            "content": "IJsland is een eiland in de Atlantische Oceaan, ver van het vasteland. Het heeft geen buurlanden op het vasteland. Het Verenigd Koninkrijk en Ierland zijn ook eilanden.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "buurlanden_eiland",
      "variantIndex": 4,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "IJsland is een eiland in de Atlantische Oceaan en heeft geen buurlanden op het vasteland. Noorwegen, Griekenland en Portugal liggen allemaal op het Europese vasteland en hebben buurlanden.",
        "solutionSteps": [
          "Welk land is een eiland?",
          "IJsland ligt in de Atlantische Oceaan",
          "Een eiland heeft geen buurlanden op het vasteland ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! IJsland is een eiland zonder buurlanden op het vasteland.",
          "1": "Je dacht waarschijnlijk dat Noorwegen een eiland is. Maar Noorwegen ligt op het Scandinavische schiereiland en grenst aan Zweden, Finland en Rusland. Onthoud: Noorwegen is verbonden met het vasteland.",
          "2": "Je dacht waarschijnlijk dat Griekenland een eiland is. Griekenland heeft veel eilanden, maar het vasteland grenst aan Albanië, Noord-Macedonië, Bulgarije en Turkije. Onthoud: het Griekse vasteland heeft buurlanden.",
          "3": "Je dacht waarschijnlijk dat Portugal een eiland is. Maar Portugal ligt op het Iberisch Schiereiland en grenst aan Spanje. Onthoud: Portugal is verbonden met het vasteland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-BUURLANDEN-004-OPT1",
            "optionIndex": 1,
            "label": "Denkfout: Noorwegen een eiland is"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-BUURLANDEN-004-OPT2",
            "optionIndex": 2,
            "label": "Denkfout: Griekenland een eiland is"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-BUURLANDEN-004-OPT3",
            "optionIndex": 3,
            "label": "Denkfout: Portugal een eiland is"
          }
        ]
      }
    },
    {
      "id": "TOPO-EU-BUURLANDEN-005",
      "familyId": "TOPO-EU-BUURLANDEN",
      "module": "Topo",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_buurlanden_eu",
      "questionType": "matching",
      "question": "Koppel elk land aan een buurland.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "leftItems": [
          "Spanje",
          "Polen",
          "Noorwegen",
          "Italië"
        ],
        "rightItems": [
          "Zweden",
          "Oostenrijk",
          "Portugal",
          "Duitsland"
        ],
        "correctMatches": {
          "0": 2,
          "1": 3,
          "2": 0,
          "3": 1
        }
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van europa",
            "region": "europa",
            "highlight": "topo_buurlanden_eu"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Buurlanden koppelen",
            "content": "Spanje → Portugal (Iberisch Schiereiland). Polen → Duitsland (oostgrens). Noorwegen → Zweden (Scandinavië). Italië → Oostenrijk (Alpen).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "buurlanden_koppelen",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Spanje grenst aan Portugal (Iberisch Schiereiland). Polen grenst aan Duitsland (in het westen). Noorwegen grenst aan Zweden (Scandinavië). Italië grenst aan Oostenrijk (via de Alpen).",
        "solutionSteps": [
          "Spanje → Portugal (samen op het Iberisch Schiereiland)",
          "Polen → Duitsland (oostgrens van Duitsland)",
          "Noorwegen → Zweden (samen in Scandinavië)",
          "Italië → Oostenrijk (gescheiden door de Alpen)"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    }
  ]
}